import {
  LOAD_SLUMP,
  SHOW_SLUMP,
  CREATE_SLUMP,
  UPDATE_SLUMP,
  DELETE_SLUMP,
  IMPORT_SLUMP,
  EXPORT_SLUMP,
} from "./actions";

const msg = {
  success_msg: "",
  err_msg: "",
};

const initialState = {
  lists: [],
  total_rows: 0,
  loading: false,
  shouldReload: false,
  data: {
    id: "",
    code: "",
    min_value: "",
    max_value: "",
    description: "",
    slump_value: "",
  },
  ...msg,
};

export default (state = initialState, action) => {
  switch (action.type) {
    case CREATE_SLUMP.REQUEST:
    case UPDATE_SLUMP.REQUEST:
    case DELETE_SLUMP.REQUEST:
    case IMPORT_SLUMP.REQUEST:
    case EXPORT_SLUMP.REQUEST:
      return {
        ...state,
        ...msg,
        loading: true,
        shouldReload: false,
      };
    case LOAD_SLUMP.REQUEST:
      return {
        ...state,
        data: initialState.data,
        ...msg,
        loading: true,
        shouldReload: false,
      };
    case SHOW_SLUMP.REQUEST:
      return {
        ...initialState,
        ...msg,
        loading: true,
        shouldReload: false,
      };

    case LOAD_SLUMP.SUCCESS:
      return {
        ...state,
        lists: action.payload.data.data,
        total_rows: action.payload.data.total_rows,
        loading: false,
      };

    case SHOW_SLUMP.SUCCESS:
      return {
        ...state,
        data: action.payload.data.data,
        loading: false,
      };

    case CREATE_SLUMP.SUCCESS:
      return {
        ...state,
        success_msg: "save_success",
        loading: false,
      };

    case UPDATE_SLUMP.SUCCESS:
      return {
        ...state,
        success_msg: "edit_success",
        loading: false,
      };

    case DELETE_SLUMP.SUCCESS:
      return {
        ...state,
        success_msg: "delete_success",
        lists: state.lists.filter((x) => x.id !== action.payload.id),
        loading: false,
        shouldReload: true,
      };

    case IMPORT_SLUMP.SUCCESS:
      return {
        ...state,
        success_msg: "import_success",
        loading: false,
        shouldReload: true,
      };

    case EXPORT_SLUMP.SUCCESS:
      return {
        ...state,
        success_msg: "export_success",
        loading: false,
      };
    case LOAD_SLUMP.FAILURE:
    case SHOW_SLUMP.FAILURE:
    case CREATE_SLUMP.FAILURE:
    case UPDATE_SLUMP.FAILURE:
    case DELETE_SLUMP.FAILURE:
    case IMPORT_SLUMP.FAILURE:
    case EXPORT_SLUMP.FAILURE:
      return {
        ...state,
        err_msg: action.payload.err,
        loading: false,
        shouldReload: false,
      };

    default:
      return state;
  }
};
